/** Issue d'une action d'authentification, dite dans la page. */
export type Notice = { kind: 'success' | 'error', text: string }

const BOX = 'rounded-md border px-3 py-2 text-sm'

/**
 * Message persistant d'un écran d'authentification (RGAA 13.1, 11.10).
 *
 * Remplace le toast suivi d'une redirection au bout de deux secondes : le
 * message disparaissait avant d'être lu, loin du formulaire. Les deux régions
 * existent dès l'affichage, pour que leur contenu soit annoncé quand il arrive.
 */
function AuthNotice({ notice }: { notice: Notice | null }) {
  const success = notice?.kind === 'success' ? notice.text : ''
  const error = notice?.kind === 'error' ? notice.text : ''
  return (
    <>
      <p role="status" className={success ? `${BOX} border-success/30 bg-success/10 text-success-text` : 'sr-only'}>{success}</p>
      <p role="alert" className={error ? `${BOX} border-destructive/30 bg-destructive/10 text-error-text` : 'sr-only'}>{error}</p>
    </>
  )
}

export default AuthNotice
